import { UserFriendlyError } from "../../../../../common/utils/base_error";
import { IUpdateCadastroCoresUseCase } from "../../../presentation/useCases/update/update_cadastro_cores_use_case";
import { IEquipamentoMedicaoRepository } from "../../repositories/EquipamentoMedicao_Repositorie";

/**
 * UpdateCadastroCoresUseCase
 */

export class UpdateCadastroCoresUseCase implements IUpdateCadastroCoresUseCase {
  constructor(private readonly repository: IEquipamentoMedicaoRepository) { }

  async updateCadastroCores(
    idCadastroCor: number,
    dataInicio: Date,
    dataFinal: Date,
    idCor: number,
    cor: string | undefined,
    corValor: string | undefined,
  ): Promise<void> {
    if (cor === undefined) throw new UserFriendlyError('A cor selecionada é inválida!');
    if (corValor === undefined) throw new UserFriendlyError('A cor selecionada é inválida!');
    await this.repository.updateCadastroCores(
      idCadastroCor,
      dataInicio,
      dataFinal,
      idCor,
      cor,
      corValor,
    );
  }
}
